import operation from '@/api/operation'
import role from '@/api/role'
import { OPERATIONTYPE } from '@/utils/dict'
import { mapGetters } from 'vuex'
import SiteSearchGroup from '@/components/search-group'
import Detail from './detail.dialog'
import help from '@/utils/help'

const columns = [
  {
    title: '',
    enTitle: 'Menu Type',
    width: 300,
    dataIndex: 'authorityName',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Operation Type',
    width: 150,
    dataIndex: 'type',
    slot: 'type'
  },
  {
    title: '',
    enTitle: 'Operator',
    width: 120,
    dataIndex: 'operator',
    slot: 'name'
  },
  {
    title: '',
    enTitle: 'Email',
    width: 150,
    dataIndex: 'operator',
    slot: 'opEmail'
  },
  {
    title: '',
    enTitle: 'Role',
    width: 200,
    dataIndex: 'roleList',
    slot: 'role'
  },
  {
    title: '',
    enTitle: 'Information',
    width: 200,
    dataIndex: 'info',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Operation Time',
    width: 150,
    dataIndex: 'createTime',
    slot: 'date'
  },
  {
    title: '',
    enTitle: 'IP',
    width: 120,
    dataIndex: 'ip'
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 80,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions'
  }
]
const MenusList = [
  {
    name: 'Publishing',
    code: 'WEBSITE',
    children: [
      {
        name: 'Publication',
        code: 'WEBSITE.PUBLISHING',
        children: [
          {
            name: 'Add',
            code: 'WEBSITE.PUBLISHING.ADD'
          },
          {
            name: 'Import',
            code: 'WEBSITE.PUBLISHING.IMPORT'
          },
          {
            name: 'Export',
            code: 'WEBSITE.PUBLISHING.EXPORT'
          },
          {
            name: 'Edit',
            code: 'WEBSITE.PUBLISHING.EDIT'
          },
          {
            name: 'Delete',
            code: 'WEBSITE.PUBLISHING.DELETE'
          },
          {
            name: 'Publish/Unpublish',
            code: 'WEBSITE.PUBLISHING.PUBLISH'
          },
          {
            name: 'Withdraw/Cancel Withdraw',
            code: 'WEBSITE.PUBLISHING.WITHDRAW'
          }
        ]
      },
      {
        name: 'Editor Board',
        code: 'WEBSITE.EDITOR_BOARD',
        children: [
          {
            name: `Editor Board's Application`,
            code: 'WEBSITE.EDITOR_BOARD.APPLY',
            children: [
              {
                name: 'Accept',
                code: 'WEBSITE.EDITOR_BOARD.APPLY.ACCEPT'
              },
              {
                name: 'Refuse',
                code: 'WEBSITE.EDITOR_BOARD.APPLY.REFUSE'
              }
            ]
          },
          {
            name: 'Create New',
            code: 'WEBSITE.EDITOR_BOARD.CREATE_NEW'
          },
          {
            name: 'Publish/Unpublish',
            code: 'WEBSITE.EDITOR_BOARD.PUBLISH'
          },
          {
            name: 'Import',
            code: 'WEBSITE.EDITOR_BOARD.IMPORT'
          },
          {
            name: 'Export',
            code: 'WEBSITE.EDITOR_BOARD.EXPORT'
          },
          {
            name: 'Download Banner',
            code: 'WEBSITE.EDITOR_BOARD.DOWNLOAD_BANNER'
          },
          {
            name: 'Download Certificate',
            code: 'WEBSITE.EDITOR_BOARD.DOWNLOAD_CERTIFICATE'
          },
          {
            name: 'Delete',
            code: 'WEBSITE.EDITOR_BOARD.DELETE'
          }
        ]
      },
      {
        name: 'Reviewer Board',
        code: 'WEBSITE.REVIEWER_BOARD',
        children: [
          {
            name: 'Create New',
            code: 'WEBSITE.REVIEWER_BOARD.CREATE_NEW'
          },
          {
            name: 'Publish/Unpublish',
            code: 'WEBSITE.REVIEWER_BOARD.PUBLISH'
          },
          {
            name: 'Import',
            code: 'WEBSITE.REVIEWER_BOARD.IMPORT'
          },
          {
            name: 'Export',
            code: 'WEBSITE.REVIEWER_BOARD.EXPORT'
          },
          {
            name: 'Download Banner',
            code: 'WEBSITE.REVIEWER_BOARD.DOWNLOAD_BANNER'
          },
          {
            name: 'Download Certificate',
            code: 'WEBSITE.REVIEWER_BOARD.DOWNLOAD_CERTIFICATE'
          },
          {
            name: 'Delete',
            code: 'WEBSITE.REVIEWER_BOARD.DELETE'
          }
        ]
      },
      {
        name: 'Special Issues',
        code: 'WEBSITE.SPECIAL_ISSUES',
        children: [
          {
            name: `Special Issues's Application`,
            code: 'WEBSITE.SPECIAL_ISSUES.APPLY',
            children: [
              {
                name: 'Accept',
                code: 'WEBSITE.SPECIAL_ISSUES.APPLY.ACCEPT'
              },
              {
                name: 'Refuse',
                code: 'WEBSITE.SPECIAL_ISSUES.APPLY.REFUSE'
              }
            ]
          },
          {
            name: 'Create New',
            code: 'WEBSITE.SPECIAL_ISSUES.CREATE_NEW'
          },
          {
            name: 'Publish/Unpublish',
            code: 'WEBSITE.SPECIAL_ISSUES.PUBLISH'
          },
          {
            name: 'Edit',
            code: 'WEBSITE.SPECIAL_ISSUES.EDIT'
          },
          // {
          //   name: 'Import',
          //   code: 'WEBSITE.SPECIAL_ISSUES.IMPORT'
          // },
          // {
          //   name: 'Export',
          //   code: 'WEBSITE.SPECIAL_ISSUES.EXPORT'
          // },
          {
            name: 'Download Banner',
            code: 'WEBSITE.SPECIAL_ISSUES.DOWNLOAD_BANNER'
          },
          {
            name: 'Download Flyer',
            code: 'WEBSITE.SPECIAL_ISSUES.DOWNLOAD_FLYER'
          },
          {
            name: 'Delete',
            code: 'WEBSITE.SPECIAL_ISSUES.DELETE'
          }
        ]
      }
    ]
  },
  {
    name: 'Editor Office',
    code: 'EDITOR_TASK',
    children: [
      {
        name: 'Manuscripts',
        code: 'EDITOR_TASK.MANUSCRIPTS',
        children: [
          {
            name: 'Edit APC',
            code: 'EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.EDIT_APC'
          }
        ]
      }
    ]
  },
  {
    name: 'System',
    code: 'SYSTEM',
    children: [
      {
        name: 'Email Management',
        code: 'SYSTEM.MAIL',
        children: [
          {
            name: 'Template Management',
            code: 'SYSTEM.MAIL.TEMPLATE',
            children: [
              {
                name: 'Add New',
                code: 'SYSTEM.MAIL.TEMPLATE.ADD_NEW'
              },
              {
                name: 'Edit',
                code: 'SYSTEM.MAIL.TEMPLATE.EDIT'
              },
              {
                name: 'Delete',
                code: 'SYSTEM.MAIL.TEMPLATE.DELETE'
              },
              {
                name: 'Publish/Unpublish',
                code: 'SYSTEM.MAIL.TEMPLATE.DISABLE'
              }
            ]
          }
        ]
      }
    ]
  }
]
export default {
  components: {
    SiteSearchGroup,
    Detail
  },
  data() {
    return {
      columns,
      OPERATIONTYPE,
      MenusList,
      roles: [],
      roleIdListArr: [],
      params: {},
      date: [],
      dataSource: [],
      inputData: {},
      showAdv: true,
      cho: 't',
      isVisable: false,
      pagination: {
        total: 0,
        size: 50,
        current: 1,
        sizeChange: true,
        onPageChange: this.getList,
        pageSizeOptions: [5, 10, 30, 50, 100], // 每页数量选项
        showQuickJumper: true
      },
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      country: 'getCountry',
      user: 'getUser'
    })
  },
  mounted() {
    this.getRoles()
    this.changeDate('7', -7)
    help.closeAutocomplete()
  },
  methods: {
    async getList(page = 1) {
      const data = Object.assign(this.params, {
        pageIndex: page,
        pageSize: this.pagination.size,
        roleIdList: this.roleIdListArr.length
          ? this.roleIdListArr.join(',')
          : ''
      })

      const { list, pageIndex, pageSize, total } = await operation.get(data)
      this.dataSource = list

      this.pagination = Object.assign(this.pagination, {
        total,
        size: pageSize,
        current: pageIndex
      })
    },
    async getRoles(val) {
      this.roles = await role.get({
        name: val
      })
    },
    handleClear() {
      this.params = {}
      this.roleIdListArr = []
      this.changeDate('7', -7)
    },
    changeDate(type, time) {
      this.cho = type
      if (type === 'time') {
        this.params.createTimeStart = time[0] ? time[0].startOf('d') : ''
        this.params.createTimeEnd = time[1] ? time[1].endOf('d') : ''
      } else if (type === 'y') {
        this.params.createTimeStart = this.$moment()
          .add(time, 'd')
          .startOf('day')
        this.params.createTimeEnd = this.$moment()
          .add(time, 'd')
          .endOf('day')
        this.date = []
      } else {
        this.params.createTimeStart = this.$moment()
          .add(time, 'd')
          .startOf('day')
        this.params.createTimeEnd = this.$moment().endOf('day')
        this.date = []
      }
      this.getList()
    },
    detail(val) {
      this.inputData = val
      this.isVisable = true
    },
    cancel() {
      this.isVisable = false
    },
    async exp() {
      this.loading = true
      try {
        const res = await operation.export(this.params)
        help.download(res.url, res.fileName)
      } catch (e) {
        this.loading = false
      }
      this.loading = false
    }
  }
}
